import {useQuery} from "react-query";
import axios from "axios";
import {GATEWAY_URL, GATEWAY_URL_REPORT} from "../../../../Config/Constants";

const apiUrl = "api/management-data";

export interface ApiResponse {
    data: Array<PowerStation>
}
export interface PowerStation {
    id: number;
    name: string;
    skidList: Array<Skid>
}

export interface Skid {
    id: number;
    name: string;
    equipmentList: Array<Equipment>
}

export interface Equipment {
    id: number;
    name: string;
    equipmentType: EquipmentType;
}

export interface EquipmentType {
    id: number;
    name: string;
}

const fetchAllSkidsConcated = async (): Promise<ApiResponse> => {
    try {
        return await axios
            .get<ApiResponse>(apiUrl + `/skidsConcated`, {
                timeout: 30000,
                baseURL: GATEWAY_URL
            })
            .then((res) => res.data);
    } catch (error : any) {
        console.error("Error fetching data:", error);
        return Promise.reject(new Error("Error fetching data: " + error.message));
    }
};

export const ManagementReportSkidsConcated = () => {
    return useQuery({
        queryKey: ["data"],
        queryFn: () => {
            return fetchAllSkidsConcated();
        }
    });
}

export interface SubReportHeader {
    id: number;
    generatedEnergyName: string | null;
    injectedEnergyName: string | null;
    expectedInjectedEnergyName: string | null;
    yieldFieldName: string | null;
    expectedYieldName: string | null;
    capacityFactorName: string | null;
    irradianceName: string | null;
    expectedIrradianceName: string | null;
    satelitalIrradianceName: string | null;
    availabilityName: string | null;
    totalAvailabilityName: string | null;
    temperatureName: string | null;
    performanceRatioName: string | null;
    expectedPerformanceRatioName: string | null;
    generationLossesName: string | null;
    generatedEnergyDeviationName: string | null;
    injectedEnergyDeviationName: string | null;
    yieldDeviationName: string | null;
    irradiationDeviationName: string | null;
    performanceRatioDeviationName: string | null;
    performanceRatioRawName: string | null;
    operationAvailabilityName: string | null;
    yieldRateName: string | null;
    irradiationGhiName: string | null;
    expectedEnergyCorrectedByIrradiationName: string | null;
    clippingLossesName: string | null;
    poairradiationClippingName: string | null;
    dinName: string | null;
    dexName: string | null;
}


export interface SubReportHeaderBySkid {
    id: number;
    generatedEnergyName: string | null;
    injectedEnergyName: string | null;
    yieldFieldName: string | null;
    expectedYieldName: string | null;
    capacityFactorName: string | null;
    irradianceName: string | null;
    expectedIrradianceName: string | null;
    availabilityName: string | null;
    totalAvailabilityName: string | null;
    temperatureName: string | null;
    performanceRatioName: string | null;
    expectedPerformanceRatioName: string | null;
    generationLossesName: string | null;
    performanceRatioRawName: string | null;
    operationAvailabilityName: string | null;
    yieldRateName: string | null;
    irradiationGhiName: string | null;
    expectedEnergyCorrectedByIrradiationName: string | null;
    clippingLossesName: string | null;
    poairradiationClippingName: string | null;
    dinName: string | null;
    dexName: string | null;
}

export interface SubReportHeaderByEquipmentInverter {
    id: number;
    generatedEnergyName: string | null;
    injectedEnergyName: string | null;
    yieldFieldName: string | null;
    expectedYieldName: string | null;
    capacityFactorName: string | null;
    irradianceName: string | null;
    expectedIrradianceName: string | null;
    availabilityName: string | null;
    totalAvailabilityName: string | null;
    temperatureName: string | null;
    performanceRatioName: string | null;
    expectedPerformanceRatioName: string | null;
    generationLossesName: string | null;
    performanceRatioRawName: string | null;
    operationAvailabilityName: string | null;
    yieldRateName: string | null;
    irradiationGhiName: string | null;
    expectedEnergyCorrectedByIrradiationName: string | null;
    clippingLossesName: string | null;
    poairradiationClippingName: string | null;
    dinName: string | null;
    dexName: string | null;
}

const fetchSubReportHeaderByPowerStation = async (): Promise<SubReportHeader> =>{
    return await axios
        .get<SubReportHeader>('/api/management-data/find-header',{
            timeout:30000,
            baseURL: GATEWAY_URL_REPORT
        })
        .then((res) => res.data)
}


const fetchSubReportHeaderBySkid = async (): Promise<SubReportHeaderBySkid> =>{
    return await axios
        .get<SubReportHeaderBySkid>('/api/management-data/find-header',{
            timeout:30000,
            baseURL: GATEWAY_URL_REPORT
        })
        .then((res) => res.data)
}

const fetchSubReportHeaderByEquipment = async (): Promise<SubReportHeaderByEquipmentInverter> =>{
    return await axios
        .get<SubReportHeaderByEquipmentInverter>('/api/management-data/find-header',{
            timeout:30000,
            baseURL: GATEWAY_URL_REPORT
        })
        .then((res) => res.data)
}

export function useSubReportHeaderPowerStationQuery() {
    return useQuery<SubReportHeader>({
        queryKey: ['data-sub-report-header', 'powerStation'],
        queryFn: fetchSubReportHeaderByPowerStation,
    });
}

export function useSubReportHeaderSkidQuery() {
    return useQuery<SubReportHeaderBySkid>({
        queryKey: ['data-sub-report-header', 'skid'],
        queryFn: fetchSubReportHeaderBySkid,
    });
}

export function useSubReportHeaderEquipmentQuery() {
    return useQuery<SubReportHeaderByEquipmentInverter>({
        queryKey: ['data-sub-report-header', 'equipment'],
        queryFn: fetchSubReportHeaderByEquipment,
    });
}